import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { PriceBreakDownDetailsViewModel } from 'models';

import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { UitkText } from 'uitk-react-text';

export interface PriceBreakDownDetailsProps {
  lodgingPriceBreakDown: PriceBreakDownDetailsViewModel;
  shouldDisplayHeader?: boolean;
  childActions?: React.ReactNode;
}

export const PriceBreakDownDetails: React.FunctionComponent<PriceBreakDownDetailsProps> = ({
  lodgingPriceBreakDown,
  shouldDisplayHeader,
  childActions
}) => {
  if (!lodgingPriceBreakDown) {
    return null;
  }
  const { header, priceBreakDownEntries, footer, unbundledEntries, ctaLabel } = lodgingPriceBreakDown;

  return (
    <div data-stid="price-breakdown-container" className="uitk-type-left all-x-margin-four">
      {priceBreakDownEntries && priceBreakDownEntries.length > 0 && (
        <>
          <table className="uitk-table experimental-pricing">
            {header && shouldDisplayHeader && (
              <caption className="uitk-table-caption">
                <strong>{header}</strong>
              </caption>
            )}
            <tbody>
              {priceBreakDownEntries.map((item, index) => (
                <PriceBreakDownRow
                  description={item.description}
                  detail={item.detail}
                  amount={item.amount}
                  key={index}
                  shouldDisplayHeader={shouldDisplayHeader}
                />
              ))}
            </tbody>
            {footer && footer.description && footer.amount && (
              <tfoot>
                <tr>
                  <td>
                    <UitkText spacing={shouldDisplayHeader ? 'half' : 'two'}>{footer.description}</UitkText>
                  </td>
                  <td>
                    <UitkText spacing={shouldDisplayHeader ? 'half' : 'two'}>{footer.amount}</UitkText>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </>
      )}
      {unbundledEntries && unbundledEntries.length > 0 && (
        <>
          <hr className="all-y-margin-two" />
          <table className="uitk-table experimental-pricing">
            <tbody>
              {unbundledEntries.map((item, index) => (
                <PriceBreakDownRow
                  description={item.description}
                  detail={item.detail}
                  amount={item.amount}
                  key={index}
                  shouldDisplayHeader={shouldDisplayHeader}
                />
              ))}
            </tbody>
          </table>
        </>
      )}

      {ctaLabel && childActions && (
        <Viewport>
          <ViewSmall>
            <UitkScrim type={UitkScrimType.BUTTON}>{childActions}</UitkScrim>
          </ViewSmall>
          <ViewMedium>
            <>{childActions}</>
          </ViewMedium>
        </Viewport>
      )}
    </div>
  );
};
PriceBreakDownDetails['displayName'] = 'PriceBreakDownDetails';

export interface PriceBreakDownRowProps {
  description?: string;
  detail?: string;
  amount?: string;
  shouldDisplayHeader?: boolean;
}
export const PriceBreakDownRow: React.FC<PriceBreakDownRowProps> = ({
  description,
  detail,
  amount,
  shouldDisplayHeader
}: PriceBreakDownRowProps) => (
  <tr>
    <td>
      {description && <UitkText spacing={shouldDisplayHeader ? 'half' : 'two'}>{description}</UitkText>}
      {detail && <UitkText size={200}>{detail}</UitkText>}
    </td>
    <td>{amount && <UitkText spacing={shouldDisplayHeader ? 'half' : 'two'}>{amount}</UitkText>}</td>
  </tr>
);
PriceBreakDownRow['displayName'] = 'PriceBreakDownRow';
